@if(generalAssetError()) {
<mat-card
  class="loren-asset-card"
  [ngClass]="{
    'loren-asset-card-grid-view': !rowView && !tableView,
    'loren-asset-card-row-view': rowView || tableView,
  }">
  <span class="loren-asset-card-error">{{
    "error_page.asset_error" | transloco
  }}</span>
</mat-card>
} @else { @if(!tableView) {
    @if(asset()) {
        <mat-card
  class="loren-asset-card"
  [ngClass]="{
    'loren-asset-card-grid-view': !rowView && !tableView,
    'loren-asset-card-row-view': rowView,
  }"
  (window:resize)="getNumberOfMetrics()">
  <mat-card-header>
    <div class="loren-asset-card-header">
      <a [routerLink]="url()" class="loren-asset-card-header-link">
        <div class="loren-asset-card-header-inner">
          <img
            class="loren-asset-card-header-image"
            alt="Avatar"
            [src]="asset().assetAvatar | lorenImage | async" />
          <span
            class="loren-asset-card-header-title"
            [matTooltip]="
              ('asset.see_details' | transloco) + ' ' + asset().assetName
            ">
            {{ asset().assetName }}
          </span>
        </div>
      </a>
    @if(hasGpsTracking() && isDashboardRoute()) {
        <button
                mat-icon-button
                class="loren-asset-card-button loren-asset-card-header-button"
                [matTooltip]="'tooltips.show_in_locations_tab' | transloco"
                [attr.aria-label]="'tooltips.show_in_locations_tab' | transloco"
                (click)="handleLocationPinClick($event)">
            <mat-icon class="loren-asset-card-header-icon">location_on</mat-icon>
        </button>
    }
      @if (canRemove) {
      <button
        mat-icon-button
        class="loren-asset-card-button loren-asset-card-header-button"
        (click)="remove.emit(asset().assetId)">
        <mat-icon class="loren-asset-card-header-icon">close</mat-icon>
      </button>
      }
    </div>
  </mat-card-header>

  <div
    class="loren-asset-card-subheader"
    [ngClass]="{ 'loren-asset-card-subheader--with-photos': showPhotos() }">
    @if(showPhotos()) {
    <div class="loren-asset-card-photos">
      @if(photosLoading()) {
      <mat-spinner [diameter]="40"></mat-spinner>
      } @else if(photosError()) {
      <div class="loren-asset-card-error">
        {{ "error_page.photos_error" | transloco }}
      </div>
      } @else {
      <button
        class="loren-asset-card-button loren-asset-card-photos-show"
        (click)="openPhotosDialog()">
        {{ "asset.photos" | transloco }} ({{ assetPhotos()?.length }})
      </button>
      <button
        class="loren-asset-card-button loren-asset-card-photos-add"
        (click)="openUploadPhotoDialog()">
        <mat-icon>add_photo_alternate</mat-icon>
        @if(!isHandset) {
        {{ "asset.add_photos" | transloco }}
        }
      </button>
      }
    </div>
    }
    <div
      class="loren-asset-card-description"
      [matTooltip]="asset().assetDescription">
      <span class="loren-asset-card-label"
        >{{ "asset.description_property" | transloco }}:
      </span>
      <span class="loren-asset-card-text">{{
        asset().assetDescription || "---"
      }}</span>
    </div>
  </div>
  @if (rowView) {
  <div
    style="display: flex;gap: 1rem;"
    [class]="'loren-asset-card-metrics-' + numberOfMetricsClassname()">
    @for(metric of showingMetrics(); track metric) {
        @if(MeticConfig[metric.type]; as config) {
            <ng-container *ngComponentOutlet="
                config.cardComponent;
                inputs: { asset: asset().assetRaw, metric: getMetering(metric.meteringId) }
            " />
        } @else {
            <loren-metric
                    class="loren-asset-card-metric"
                    [assetRaw]="asset().assetRaw"
                    [metricRaw]="getMetering(metric.meteringId)"
                    [assetId]="asset().assetId"
                    [metric]="metric"
                    [avatar]="asset().assetAvatar"/>
        }
    }

  </div>
  @if(showingMetrics().length < asset().meteringViews.length) {
  <div>
    <div class="loren-asset-card-count loren-asset-card-count-row">
      <button
        class="loren-asset-card-button"
        [ngClass]="{ transparent: currentMetric() === 0 }"
        (click)="changeMetric(currentMetric() - 1)">
        <mat-icon
          class="loren-asset-card-count-arrow loren-asset-card-count-arrow--row"
          >chevron_left</mat-icon
        >
      </button>
      @for( item of [].constructor(pagesNumber()); let i = $index; track item) {
      <button
        type="button"
        class="loren-asset-card-count-dot"
        [attr.aria-label]="'Go to metric ' + (i + 1)"
        [ngClass]="{
          'loren-asset-card-count-dot--active': currentMetric() === i
        }"
        (click)="changeMetric(i)"></button>
      }
      <button
        class="loren-asset-card-button"
        [ngClass]="{
          transparent: currentMetric() + 1 === pagesNumber()
        }"
        (click)="changeMetric(currentMetric() + 1)">
        <mat-icon
          class="loren-asset-card-count-arrow loren-asset-card-count-arrow--row"
          >chevron_right</mat-icon>
      </button>
    </div>

  </div>

  } } @else {
      @let metric = showingMetrics()[0];

      @if (MeticConfig[metric.type]; as config) {
          <ng-container *ngComponentOutlet="
                config.cardComponent;
                inputs: { asset: asset().assetRaw, metric: getMetering(metric.meteringId) }
            "/>
      } @else {
          <loren-metric
                  class="loren-asset-card-metric"
                  [assetRaw]="asset().assetRaw"
                  [metricRaw]="getMetering(metric.meteringId)"
                  [assetId]="asset().assetId"
                  [metric]="metric"
                  [avatar]="asset().assetAvatar"/>
      }

  <div
    class="loren-asset-card-count"
    [ngClass]="{ centered: !hasMultipleMetrics() }">
    @if (hasMultipleMetrics()) {
    <button
      class="loren-asset-card-button"
      [ngClass]="{ transparent: currentMetric() === 0 }"
      (click)="changeMetric(currentMetric() - 1)">
      <mat-icon class="loren-asset-card-count-arrow">chevron_left</mat-icon>
    </button>
    }
    <span
      ><span class="loren-asset-card-count-current">{{
        currentMetric() + 1
      }}</span>
      / {{ asset().meteringViews.length }}
      @if(!isHandset) {
      {{ "asset.metrics" | transloco }}
      }</span>
    @if (hasMultipleMetrics()) {
    <button
      class="loren-asset-card-button"
      [ngClass]="{
        transparent: currentMetric() === asset().meteringViews.length - 1
      }"
      (click)="changeMetric(currentMetric() + 1)">
      <mat-icon class="loren-asset-card-count-arrow">chevron_right</mat-icon>
    </button>
    }
  </div>
  }
  <!---->
</mat-card>
    }
} @else {
    @if(asset()) {
        <div class="loren-asset-card-table-container">
      <div
        class="loren-asset-card-table-header"
        [ngClass]="{
            'loren-asset-card-table-header--first': first,
          }">
        <a [routerLink]="url()" class="loren-asset-card-header-link">
          <div class="vertically-centered">
            <img
              class="loren-asset-card-header-image"
              alt="Avatar"
              [src]="asset().assetAvatar | lorenImage | async" />
            <span
              routerLink="/"
              class="loren-asset-card-header-title"
              [matTooltip]="
                ('asset.see_details' | transloco) + ' ' + asset().assetName
              ">
              {{ asset().assetName }}
            </span>
          </div>
        </a>

        <div [matTooltip]="asset().assetDescription">
          <span class="loren-asset-card-label"
            >{{ "asset.description_property" | transloco }}:
          </span>
          <span class="loren-asset-card-text">{{
            asset().assetDescription || "---"
          }}</span>
        </div>
      </div>
      <div class="loren-asset-card-table">
        <div></div>
        <div class="loren-asset-card-table-th">
          {{ "asset.metric" | transloco }}
        </div>
        <div class="loren-asset-card-table-th">
          {{ "asset.description_property" | transloco }}
        </div>
        <div class="loren-asset-card-table-th">
          {{ "asset.value" | transloco }}
        </div>
        <div class="loren-asset-card-table-th">
          {{ "asset.updated" | transloco }}
        </div>
        <div class="loren-asset-card-table-th" style="text-align: right">
          {{ "asset.battery" | transloco }}
        </div>
      </div>

            @for (metric of asset().meteringViews; track metric; ) {
                <loren-metric
                        [assetRaw]="asset().assetRaw"
                        [metricRaw]="getMetering(metric.meteringId)"
                        [assetId]="asset().assetId"
                        [isTableView]="true"
                        [metric]="metric"
                        [avatar]="asset().assetAvatar"
                />
            }
    </div>
    }
} }
